exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.center_item[data-v-1f2fcb92]{\n    text-align: center\n}\n.passenger_list[data-v-1f2fcb92]{\n    margin-top: 20px;\n    margin-bottom: 20px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    border-top: 1px solid #e9ecef;\n    border-bottom: 1px solid #eaedf1;\n}\n", ""]);

// exports
